import { useLocation } from "react-router-dom";
import { Onboarding } from "sdk/onboardings";
import { routes } from "~/constants";
import { usePartner } from "~/OnboardingApp/hooks";
import { useOnboarding } from "~/OnboardingApp/hooks/useOnboarding";
import { getNextStep, getPreviousStep } from "../utils";
import { useMetaByPathConfig } from "./useMetaByPathConfig";

export const useRouteMeta = () => {
  const location = useLocation();
  const attemptingRoute = location.pathname;
  const { handleSetOnboarding, ...onboarding } = useOnboarding();
  const { metaByPath, questionnaireOrder } = useMetaByPathConfig();
  const { isPartner, partnerSlugify } = usePartner();

  const rootRoute = isPartner
    ? partnerSlugify(routes.partnerSlugRoot)
    : `${routes.root}?force=1`;

  const args = {
    attemptingRoute,
    onboarding,
    metaByPath,
    questionnaireOrder,
  };

  const nextStepData = getNextStep(args);
  const previousStepData = getPreviousStep({ rootRoute, ...args });

  return {
    nextStepData,
    previousStepData,
    recalculateNextStep: (onboarding: Partial<Onboarding>) =>
      getNextStep({ ...args, onboarding }),
  };
};
